var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJwticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8174 6.47541L13.7933 0H10.1826L10.2067 6.47541L12.012 8.95491L13.8174 6.47541ZM10.2067 17.5727V24.0722H13.8174V17.5727L12.012 15.0933L10.2067 17.5727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8175 17.5727L17.6209 22.8204L20.5336 20.7021L16.7302 15.4544L13.8175 14.5155V17.5727ZM10.2067 6.4754L6.37915 1.22765L3.46643 3.34603L7.26987 8.59378L10.2067 9.53259V6.4754Z",
    fill: "#00F2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26984 8.59378L1.10728 6.59578L0 10.014L6.16247 12.0361L9.07519 11.0732L7.26984 8.59378ZM14.9248 12.9749L16.7302 15.4544L22.8927 17.4523L24 14.0341L17.8375 12.0361L14.9248 12.9749Z",
    fill: "#00B9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8375 12.0361L24 10.014L22.8927 6.59578L16.7302 8.59378L14.9248 11.0732L17.8375 12.0361ZM6.16247 12.0361L0 14.0341L1.10728 17.4523L7.26984 15.4544L9.07519 12.9749L6.16247 12.0361Z",
    fill: "#D63AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26987 15.4544L3.46643 20.7021L6.37915 22.8204L10.2067 17.5727V14.5155L7.26987 15.4544ZM16.7302 8.59378L20.5336 3.34603L17.6209 1.22765L13.8175 6.4754V9.53259L16.7302 8.59378Z",
    fill: "#FB015B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0938,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwticon);
export default __webpack_public_path__ + "static/media/jwticon.a85afe3180c9f55c325b0bd0775c681f.svg";
export { ForwardRef as ReactComponent };